import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, catchError, switchMap, exhaustMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
import { Store } from '@ngrx/store'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { OfficeService } from '../../services/office.service'
import {
  createOffice,
  createOfficeFailure,
  createOfficeSuccess,
  loadOffices,
  loadOfficesFailure,
  loadOfficesSuccess,
  updateOffice,
  updateOfficeFailure,
  updateOfficeSuccess
} from './office.actions'

export const loadOffices$ = createEffect(
  (actions$ = inject(Actions), officeService = inject(OfficeService)) =>
    actions$.pipe(
      ofType(loadOffices),
      switchMap(
        (
          action // Use action.filter here
        ) =>
          officeService.getOffices(action.params, action.page, action.limit).pipe(
            map(res =>
              loadOfficesSuccess({
                totalCount: res.totalCount,
                offices: res.offices
              })
            ),
            catchError(error => of(loadOfficesFailure({ error: error.message })))
          )
      )
    ),
  { functional: true }
)

export const createOffice$ = createEffect(
  (
    actions$ = inject(Actions),
    officeService = inject(OfficeService),
    toastr = inject(ToastrService), // Inject the ToastrService
    store = inject(Store),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(createOffice),
      exhaustMap(({ officeName, businessId }) =>
        officeService.createOffice({ officeName, businessId }).pipe(
          map(created => {
            // Dispatch the success action
            const successAction = createOfficeSuccess({ office: created })

            // Show a success message using Toastr
            toastr.success('Office created successfully!', 'Success')
            // store.dispatch(loadOffices({ params: null, page: 1, limit: 10 }))
            // modalService.dismissAll()
            return successAction
          }),
          catchError(error => {
            // Optionally, show an error message
            toastr.error('There was an error creating the Office.', 'Error')
            return of(createOfficeFailure({ error }))
          })
        )
      )
    ),
  { functional: true, dispatch: true }
)

export const updateOffice$ = createEffect(
  (
    actions$ = inject(Actions),
    officeService = inject(OfficeService),
    toastr = inject(ToastrService)
    // store = inject(Store)
  ) =>
    actions$.pipe(
      ofType(updateOffice),
      exhaustMap(({ id, officeName, address, cityId, zipCode }) =>
        officeService
          .updateOffice({
            id,
            officeName,
            address,
            cityId,
            zipCode
          })
          .pipe(
            map(updatedOffice => {
              toastr.success('Office updated successfully!', 'Success')

              // Dispatch loadBusinessById after the update is successful
              //   store.dispatch(loadBusinessById({ id }))

              // Dispatch success action to update the store
              return updateOfficeSuccess({ office: updatedOffice })
            }),
            catchError(error => {
              toastr.error('Failed to update office', 'Error') // Show error message
              return of(updateOfficeFailure({ error }))
            })
          )
      )
    ),
  { functional: true }
)

export const officeEffects = {
  loadOffices$,
  createOffice$,
  updateOffice$
}
